import SearchIcon from "@redotech/redo-icons/search-sm_filled.svg";
import { CommandPalette } from "@redotech/redo-web/command-palette/components/command-palette";
import { useMetaKey } from "@redotech/redo-web/command-palette/hooks/use-meta-key";
import { Button } from "@redotech/redo-web/components/ui/button";
import { PopoverTrigger } from "@redotech/redo-web/components/ui/popover";
import { memo } from "react";

export const SearchButton = memo(function SearchButton() {
  const metaKey = useMetaKey();

  return (
    <CommandPalette>
      <PopoverTrigger asChild>
        <Button
          className="max-w-[520px] w-full shrink min-w-0 opacity-90 hover:opacity-100 box-shadow-sm"
          size="sm"
          variant="default"
        >
          <SearchIcon className="size-4 text-white" />
          <span className="text-xs text-white">Search</span>
          <div className="ml-auto flex text-[10px] opacity-70 bg-transparent text-white rounded-sm gap-1 border border-white/20 px-1">
            <span>{metaKey}</span>
            <span>K</span>
          </div>
        </Button>
      </PopoverTrigger>
    </CommandPalette>
  );
});
